<template>
  <b-row>
    <b-col cols="12">
      <b-form @submit.prevent>
        <b-form-group label="انتخاب سطح استاد" label-for="master-level-picker">
          <v-select
            id="master-level-picker"
            dir="rtl"
            v-if="levelsList"
            :reduce="(level) => level.id"
            v-model="selectedLevel"
            :options="levelsList"
            label="title"
            placeholder="سطح استاد را انتخاب کنید"
          >
            <template #no-options>
              هیچ سطح استادی جهت نمایش وجود ندارد
            </template>
          </v-select>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>
</template>
<script>
export default {
  emits: ["getMasterLevelId"],
  props: {
    defaultSelectedLevel: {
      type: Number,
      required: false,
      default: null,
    },
  },
  watch: {
    selectedLevel: {
      handler(val) {
        this.$emit("getMasterLevelId", val);
      },
    },
  },
  mounted() {
    this.getAllMastersLevels();
  },
  data() {
    return {
      levelsList: null,
      selectedLevel: null,
    };
  },
  methods: {
    async getAllMastersLevels() {
      try {
        let _this = this;
        let getAllMastersLevelsLight = new GetAllMastersLevelsLight(_this);
        await getAllMastersLevelsLight.fetch((res) => {
          _this.levelsList = res;
          if (_this.defaultSelectedLevel) {
            _this.selectedLevel = _this.levelsList.find(
              (item) => item.id == _this.defaultSelectedLevel
            ).id;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
  },
};
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { GetAllMastersLevelsLight } from "@/libs/Api/ScheduleMasterRegular";
</script>
